import { FunctionComponent, ReactNode } from 'react'

import { Root, Indicator } from '@radix-ui/react-checkbox'
import styled from 'styled-components'

import { baseColors } from '../../primitives/colors'
import { Tick } from '../icons/Tick'
import { Text } from '../Text'

const Container = styled.div<{ isChecked: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid ${baseColors.borderBackground};
  border-radius: 10px;
  background-color: ${({ isChecked }) =>
    isChecked
      ? baseColors.backgroundsPrimarySurface
      : baseColors.backgroundCard};
  color: ${baseColors.contentContent};
  &:hover {
    background-color: ${({ isChecked }) =>
      isChecked
        ? baseColors.backgroundsPrimarySurface
        : baseColors.statesHoverBackground};
    color: ${({ isChecked }) =>
      isChecked ? baseColors.contentContent : baseColors.backgroundCard};

    button {
      background-color: ${({ isChecked }) =>
        isChecked ? baseColors.contentMuted : baseColors.backgroundCard};
      color: ${({ isChecked }) =>
        isChecked
          ? baseColors.backgroundsPrimarySurface
          : baseColors.statesHoverBackground};
    }
  }
`

const StyledRoot = styled(Root)`
  background-color: ${({ checked }) =>
    checked ? baseColors.contentMuted : 'transparent'};
  min-width: 25px;
  width: 25px;
  height: 25px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${baseColors.contentMuted};
  margin-left: 24px;
  color: ${baseColors.backgroundsPrimarySurface};

  &:focus-visible {
    outline: 2px solid ${baseColors.statesFocus};
    outline-offset: 2px;
  }
`

const StyledIndicator = styled(Indicator)`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Label = styled(Text)`
  flex-grow: 1;
  cursor: pointer;
  padding: 16px 24px 16px 18px;
`

export interface CheckboxItem {
  id: string
  isChecked: boolean
  onCheckedChange: (checked: boolean) => void
  label: ReactNode
}

export interface CheckboxProps {
  item: CheckboxItem
  className?: string
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  item: { id, isChecked, onCheckedChange, label },
  className,
}) => (
  <Container className={className} isChecked={isChecked}>
    <StyledRoot checked={isChecked} onCheckedChange={onCheckedChange} id={id}>
      <StyledIndicator>
        <Tick width="13" height="13" />
      </StyledIndicator>
    </StyledRoot>
    <Label element="label" type="body" size="sm" fontWeight={500} htmlFor={id}>
      {label}
    </Label>
  </Container>
)
